import { MAX_TYPING_SECONDS } from "@velizhanin-dev/bot-scenario"
import { Plus, SlidersHorizontal } from "lucide-react"
import { useId, useState } from "react"
import { Checkbox } from "@/shared/ui/checkbox"
import { Field } from "@/shared/ui/form-field"
import { Input } from "@/shared/ui/input"
import { type Config, parseOptionalNumber, readNumber, withField } from "./editor-props"

/** «Печатает…», без звука, запрет пересылки: опции любого сообщения бота. */
export function SendOptionsFields({
	config,
	onChange,
}: {
	config: Config
	onChange: (next: Config) => void
}) {
	const [open, setOpen] = useState(
		readNumber(config, "typingSeconds") !== undefined ||
			config.silent === true ||
			config.protect === true ||
			config.noLinkPreview === true,
	)
	const previewId = useId()
	const silentId = useId()
	const protectId = useId()
	if (!open) {
		return (
			<button
				type="button"
				onClick={() => setOpen(true)}
				className="flex w-full items-center gap-3 rounded-xl border border-dashed border-border px-3 py-2.5 text-left transition-colors hover:border-foreground/25 hover:bg-secondary/30"
			>
				<SlidersHorizontal className="size-4 shrink-0 text-muted-foreground" />
				<span className="min-w-0 flex-1">
					<span className="block text-sm font-medium">Настройки отправки</span>
					<span className="block text-xs text-muted-foreground">
						«Печатает…», без звука, без превью ссылок, запрет пересылки
					</span>
				</span>
				<Plus className="size-4 shrink-0 text-muted-foreground" />
			</button>
		)
	}
	return (
		<Field label="Настройки отправки">
			<div className="space-y-2.5 rounded-xl border border-border p-3">
				<div className="flex items-center gap-2 text-sm">
					<span className="shrink-0">«Печатает…»</span>
					<Input
						type="number"
						min={1}
						max={MAX_TYPING_SECONDS}
						aria-label="Сколько секунд показывать «печатает…»"
						placeholder="нет"
						className="h-8 w-20"
						value={readNumber(config, "typingSeconds") ?? ""}
						onChange={(event) =>
							onChange(withField(config, "typingSeconds", parseOptionalNumber(event.target.value)))
						}
					/>
					<span className="text-muted-foreground">секунд перед сообщением</span>
				</div>
				<label className="flex items-center gap-2 text-sm" htmlFor={silentId}>
					<Checkbox
						id={silentId}
						checked={config.silent === true}
						onCheckedChange={(checked) =>
							onChange(withField(config, "silent", checked === true || undefined))
						}
					/>
					Без звука уведомления
				</label>
				<label className="flex items-center gap-2 text-sm" htmlFor={protectId}>
					<Checkbox
						id={protectId}
						checked={config.protect === true}
						onCheckedChange={(checked) =>
							onChange(withField(config, "protect", checked === true || undefined))
						}
					/>
					Запретить пересылку и сохранение
				</label>
				<label className="flex items-center gap-2 text-sm" htmlFor={previewId}>
					<Checkbox
						id={previewId}
						checked={config.noLinkPreview === true}
						onCheckedChange={(checked) =>
							onChange(withField(config, "noLinkPreview", checked === true || undefined))
						}
					/>
					Без превью ссылок
				</label>
			</div>
		</Field>
	)
}
